// extracted by mini-css-extract-plugin
export default {"container":"LegendScaleSlider_container__XdUaj","inputNumberContainer":"LegendScaleSlider_inputNumberContainer__Hx3ye","inputWrapper":"LegendScaleSlider_inputWrapper__eLBNy"};